import React from 'react';
import { Button } from '../../../../../../../../components/Common/UI/Button';
import Separator from '../../../../../../../../components/Common/UI/Separator';
import { TabCount, useMessageManagerProvider } from '../../../../../../../context/messageManager';
import CriteriaBlock from './CriteriaBlock';
import TemplateBlock from './TemplateBlock';
import MediaBlock from './MediaBlock';
import TextBlock from './TextBlock';
import StatementBlock from './StatementBlock';
import { convertToAlphabetic } from '../../../../../../../../utils';

interface ModuleEditProps {
  tab: number;
}

function ModuleEdit({ tab }: ModuleEditProps) {
  const { selectedModule, isTextOnly, state } = useMessageManagerProvider();

  const { endOfStatement } = state.step2;
  const isEndOfStatementText = tab === 1 && endOfStatement.data[1]?.id === endOfStatement.selected?.id;

  return (
    <div className="grid gap-[10px] h-full content-start">
      {tab === 0 ? (
        <div className="bg-primary text-white text-xl font-bold p-[6px_10px]">
          {`Now Editing Tab ${convertToAlphabetic((selectedModule?.textTabIndex || 0) + 1)}
            of Module ${TabCount[selectedModule?.imageTabIndex || 0]}:`}
        </div>
      ) : null}

      {endOfStatement?.selected && tab === 1 ? (
        <div className="bg-primary text-white text-xl font-bold p-[6px_10px]">
          {`Now Editing Tab ${TabCount[endOfStatement.data.indexOf(endOfStatement.selected)]}
              of Module ${TabCount[selectedModule?.imageTabIndex || 0]}:`}
        </div>
      ) : null}
      <StatementBlock tab={tab} />
      <Separator className="my-[10px]" />
      <CriteriaBlock tab={tab} />
      <Separator className="my-[10px]" />
      <TemplateBlock />
      <Separator className="my-[10px]" />
      {(isTextOnly && tab === 0) || isEndOfStatementText ? <TextBlock tab={tab} /> : <MediaBlock tab={tab} />}
      <Separator className="my-[10px]" />
      <div className="flex justify-self-end items-center mb-[20px] px-[10px] gap-[10px]">
        <div className="text-sm text-primary opacity-50 first-letter:uppercase lowercase">
          {tab === 0
            ? `Changes will be applied to module ${TabCount[selectedModule?.imageTabIndex || 0]}, tab
            ${convertToAlphabetic((selectedModule?.textTabIndex || 0) + 1)}`
            : null}
          {endOfStatement?.selected && tab === 1
            ? `Changes will be applied to module ${TabCount[selectedModule?.imageTabIndex || 0]}, tab
            ${TabCount[endOfStatement.data.indexOf(endOfStatement.selected)]}`
            : null}
        </div>
        <Button>Apply Changes</Button>
      </div>
    </div>
  );
}

export default ModuleEdit;
